module.exports = __webpack_public_path__ + "img/038-gift.a535cad3.png";